<div class="migration-banner fixed-top">
    <app-migration-banner *ngIf="enabledBannerThroughConfiguration"></app-migration-banner>
    <nav id="navbar" class="navbar navbar-expand-md navbar-dark scroll-color"
        [ngClass]="{'fixed-top-color' : scrollNavBar, 'login-bg' : loggedIn && currentRoute == 'account'}">
        
        <div class="container-fluid d-flex justify-content-between align-items-center">
            <a class="navbar-brand" routerLink="/"></a>

            <div class="d-flex align-items-center">

                <!-- User Dropdown Menu visible only when logged in -->
                <ul class="navbar-nav" *ngIf="loggedIn">
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" id="dropMenu" href="#" role="button" data-bs-toggle="dropdown"></a>
                        
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" *ngIf="!inputCard" routerLink="/account/myAcount">{{'gen_profile' | translate}}</a></li>
                            <div class="green-line" *ngIf="!inputCard"></div>
                            <li><a class="dropdown-item" *ngIf="!inputCard" routerLink="/account/myChargingRecords">{{'gen_cdrs_charges' | translate}}</a></li>
                            <div class="green-line" *ngIf="!inputCard"></div>
                            <li><a class="dropdown-item" *ngIf="!inputCard" routerLink="/account/changePersonalInfo" [innerHTML]="'gen_change_personal' | translate"></a></li>
                            <div class="green-line" *ngIf="!inputCard && cardEKO != 9"></div>
                            <li *ngIf="cardEKO != 9"><a class="dropdown-item" *ngIf="!inputCard" routerLink="/account/changeBankCard" [innerHTML]="'gen_change_bank_card' | translate"></a></li>
                            <li class="logout-bg" [ngClass]="{'mar-top' : inputCard }"><a class="dropdown-item logout-bold" (click)="openLogoutDialog()">{{'gen_logout' | translate}}</a></li>
                        </ul>
                    </li>
                </ul>

                <!-- Language-->
                <a class="nav-link lang" (click)="changeLanguage()"> {{'btn_language' | translate}} </a>
            </div>
        </div>
    </nav>
</div>